import React from 'react'
import { Icon, Typography } from 'antd'
import './index.less'

const { Title } = Typography

export function GiftPageHero() {
  return (
    <div className='gift-page-hero'>
      <Title level={2}>Envie para seu amigo um presente personalizado</Title>
      <iframe
        width='640'
        height='480'
        src='https://youtube.com/embed/H0pynawj54k?autoplay=1'
      />
      <div className='gift-page-hero-arrow'>
        <a href='#gift-text'>
          <Icon type='down-circle' />
        </a>
      </div>
    </div>
  )
}
